module.exports = __webpack_public_path__ + "img/service_partnerships.0571d3b5.svg";